import React, { useEffect, useState } from 'react';

const RecentArticles = () => {
     const mobileWidth = 700;
     const [posts, setPosts] = useState([]);
     const [isMobile, setIsMobile] = useState(window.innerWidth < mobileWidth);

     useEffect(() => {
          const handleResize = () => {
               setIsMobile(window.innerWidth < mobileWidth);
          };
          window.addEventListener("resize", handleResize);
          return () => window.removeEventListener("resize", handleResize);
     }, []);

     useEffect(() => {
          const fetchFeed = async () => {
               try {
                    const res = await fetch(
                         'https://api.rss2json.com/v1/api.json?rss_url=https://rss.beehiiv.com/feeds/qFNTFAaSaC.xml'
                    );
                    const data = await res.json();
                    setPosts(data.items.slice(0, 3)); // Top 3 posts
               } catch (err) {
                    console.error('Failed to fetch Beehiiv RSS feed:', err);
               }
          };

          fetchFeed();
     }, []);

     return (
          <div>
               <div style={{fontSize: "12px", textAlign: "right", marginTop: "5px", marginRight: "30px"}}>
                    <a href={"https://lucimoneymoves.beehiiv.com"} target="_blank">
                         View All Blog Posts →
                    </a>
               </div>
               <div style={{
                    display: "flex",
                    flexDirection: isMobile? "column" : "row",
                    rowGap: "30px",
                    columnGap: "20px",
                    margin: "5px 20px 30px 20px"
               }}>
                    {posts.map((post) => (
                         <a
                              href={post.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ textDecoration: 'none', color: '#1a1a1a' }}
                         >
                              <div key={post.guid} style={{ minWidth: "200px", maxWidth: "300px" }}>
                                   <img src={post.enclosure.link} alt={post.title} style={{width: "100%", borderRadius: "20px"}}/>
                                   <div style={{ margin: "5px 10px"}}>
                                        <div style={{ color: '#aaa', fontSize: '12px' }}>
                                             {new Date(post.pubDate).toLocaleDateString()}
                                        </div>
                                        <div style={{ fontSize: '14px', fontWeight: "600", lineHeight: "20px" }}>
                                             {post.title}
                                        </div>
                                   </div>
                              </div>
                         </a>
                    ))}
               </div>

          </div>
          
     );
};

export default RecentArticles;
